const FormGroupTypes = [
  {
    key: 'crsiw8ben',
    formTypes: ['crsi_2024', 'w8ben_2021']
  },
];

export default FormGroupTypes;
